import axios from 'axios';
import { createForumCsrfProtection } from './forumCsrf';

// Centralised Axios instance for all forum related API calls.
// If the API ever moves to another sub-domain or needs auth headers, edit only this file.
const forumApi = axios.create({
  baseURL: '/', // same origin; adjust if the backend is served elsewhere
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true // send cookies for Drupal sessions
});

const csrf = createForumCsrfProtection({
  getIdentity: () => ({ uid: localStorage.getItem('uid'), session: localStorage.getItem('user_access_token') }),
  fetchSession: async () => {
    const response = await forumApi.get('/forum/api/v2/session', { timeout: 10000 });
    return response.data && response.data.data;
  }
});
forumApi.interceptors.request.use(config => csrf.prepare(config));

// Do not log Axios configs containing CSRF tokens or user-written content.
forumApi.interceptors.response.use(
  response => response,
  error => {
    const payload = error.response && error.response.data;
    if (payload && (payload.code === 'csrf_invalid' || (payload.error && payload.error.code === 'csrf_invalid'))) csrf.invalidate();
    if (error.config) {
      // Legacy callers still report errors; do not forward token/body there.
      delete error.config.data;
      if (error.config.headers) Object.keys(error.config.headers).forEach(key => {
        if (key.toLowerCase() === 'authorization') delete error.config.headers[key];
      });
    }
    return Promise.reject(error);
  }
);

export default forumApi;
